import { ConsignmentVendorProductListPage } from "@/features/consignment-vendor-product/pages/ConsignmentVendorProductListPage";
import { createFileRoute } from "@tanstack/react-router";

// List stays mounted under detail.
export const Route = createFileRoute("/vendor/consignment-vendor-product")({
	component: ConsignmentVendorProductListPage,
});
